export default __webpack_public_path__ + "static/media/bar-pricing.9518bfc4.svg";